import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import * as resourcesActions from '../../../actions/resourcesActions';
import * as actionTypes from '../../../actions/actionTypes';
import * as localeStorage from '../../../localStorage/localStorage';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as environmentHelper from '../../../helpers/environmentHelper';


class ResourcesButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            ariaHasPopup: true,
            lang: this.props.lang,
            label: appHelper.getLocaleString("resources_label"),
            env: environmentHelper.getEnvironment(),
        };
        this.setResourcesStatus = this.setResourcesStatus.bind(this);
        this.setBtnClass = this.setBtnClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("resources_label"),
            });
        }
    }

    setResourcesStatus() {
        if(!this.props.disabled || this.props.displayResources === actionTypes.STATUS_OPEN) {
            switch (this.props.displayResources) {
                case actionTypes.STATUS_CLOSED:
                    this.props.actions.setResourcesDisplay(actionTypes.STATUS_OPENING);
                    break;
                case actionTypes.STATUS_OPEN:
                    this.props.actions.setResourcesDisplay(actionTypes.STATUS_CLOSING);
                    break;
                default:
                    break;
            }
        }
    }

    setBtnClass(){
        return this.props.disabled && this.props.displayResources !== actionTypes.STATUS_OPEN ? "disabled" : "";
    }

    setIconClass(){
        if(this.props.displayResources === actionTypes.STATUS_OPEN){
            return "icons8-multiply";
        }else{
            return "icons8-toolbox-filled";
        }
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.setResourcesStatus();
        }
    }

    render() {
        return (

                (appHelper.isDefined(this.props.contentData.experience.show_icons) && this.props.contentData.experience.show_icons) || !appHelper.isDefined(this.props.contentData.experience.show_icons) || this.state.env.isDevice
                    ?
                    <div className={`header-btn ${this.setBtnClass()}`} onClick={this.setResourcesStatus} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="resources" id="resourcesBtn" title={appHelper.getLocaleString("resources_label")} aria-haspopup={this.state.ariaHasPopup}>
                        <div className={`icon ${this.setIconClass()} `} />
                        <div className="btn-label">{this.state.label}</div>
                    </div>
                    :
                    <div className={`header-btn`} onClick={this.setResourcesStatus} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="resources" id="resourcesBtn" title={appHelper.getLocaleString("resources_label")} aria-haspopup={this.state.ariaHasPopup}>
                        <div className="nav-label">{this.state.label}</div>
                    </div>



        );
    }
}

ResourcesButton.propTypes = {
    disabled: PropTypes.bool.isRequired,
    displayResources: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    contentData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

ResourcesButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        displayResources: state.displayResources,
        lang:lang,
        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions, resourcesActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ResourcesButton);



/** WEBPACK FOOTER **
 ** ./src/components/dialogs/resources/ResourcesBtn.js
 **/